import React from "react";
import '../modal/Modal.css';
import close from '../../../img/close.svg';

export default function Modal({open,children,onClose}){
    if(!open) return null
    return(
    <div className="background-style">
    <div className="modal">
            <div className="close-container">
                <img src={close} className="close-btn" onClick={onClose} />
            </div>
            {children} 
    </div>
    </div>
    )
}